export default __webpack_public_path__ + "static/media/interview03_2.e35ccd37.jpg";